import { request } from '../../../../lib/request';
import { SUSHI_DATA_API_HOST } from 'sushi/config/subgraph';
import { graphql } from '../../graphql';
import { SUSHI_REQUEST_HEADERS } from '../../request-headers';
export const SmartPoolsQuery = graphql(`
  query SmartPools($chainId: SmartPoolChainId!) {
    smartPools(chainId: $chainId) {
      id
      address
      chainId
      poolAddress
      address
      swapFee
      strategy
      description
      protocol
      token0 {
        id
        chainId
        address
        name
        symbol
        decimals
      }
      token1 {
        id
        chainId
        address
        name
        symbol
        decimals
      }
      liquidityUSD
      vaultLiquidityUSD
      feeUSD1d
      feeApr1d
      feeAndIncentiveApr1d
      stakedApr1d
      stakedAndIncentiveApr1d
      incentiveApr
      wasIncentivized
      isIncentivized

      isEnabled
      wasEnabled
      isDeprecated
    }
  }
`);
export async function getSmartPools(variables, options) {
    const url = `https://${SUSHI_DATA_API_HOST}`;
    const result = await request({
        url,
        document: SmartPoolsQuery,
        variables,
        requestHeaders: SUSHI_REQUEST_HEADERS,
    }, options);
    if (result) {
        return result.smartPools.map((pool) => ({
            ...pool,
            chainId: pool.chainId,
            id: pool.id,
            strategy: pool.strategy,
            token0: {
                id: pool.token0.id,
                address: pool.token0.address,
                chainId: pool.token0.chainId,
                decimals: pool.token0.decimals,
                name: pool.token0.name,
                symbol: pool.token0.symbol,
            },
            token1: {
                id: pool.token1.id,
                address: pool.token1.address,
                chainId: pool.token1.chainId,
                decimals: pool.token1.decimals,
                name: pool.token1.name,
                symbol: pool.token1.symbol,
            },
        }));
    }
    throw new Error('No smart pools found');
}
